import { render, staticRenderFns } from "./scoped-route-link.vue?vue&type=template&id=cc20fe20&"
import script from "./scoped-route-link.vue?vue&type=script&lang=js&"
export * from "./scoped-route-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports